import axios from 'axios';

export const HTTPDSP = axios.create({
  baseURL: `https://alsukkary.sd.zain.com/DSPAPIs/APIs/`
})
